module.exports = __webpack_public_path__ + "hu.svg?d1065faa141b030f4d6317927525ec32";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/hu.svg
// module id = 1408
// module chunks = 0